var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":(_vm.pageList.indexOf(_vm.$route.name) < 0)?'App':'Apps'}},[(_vm.pageList.indexOf(_vm.$route.name) < 0)?_c('BaseNav'):_vm._e(),(_vm.isShowBanner)?_c('el-image',{staticStyle:{"width":"100%","height":"580px"}}):_vm._e(),_c('router-view'),(_vm.pageList.indexOf(_vm.$route.name) < 0)?_c('BaseFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }